import React, { createContext, useState, useRef, useCallback } from "react";

export const GraffitiContext = createContext(null);

export const GraffitiProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  const triggerGraffiti = useCallback(() => {
    setVisible(true);

    clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      setVisible(false);
    }, 3000);
  }, []);

  return (
    <GraffitiContext.Provider value={{ visible, triggerGraffiti }}>
      {children}
    </GraffitiContext.Provider>
  );
};
